import Image from 'next/image';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { JobTypeFieldOption } from 'modules/job-types/types';

import styles from './LearningRequestFormEntry.module.scss';

interface Props {
  onSubmit: (age: string | number) => void;
  options: Array<JobTypeFieldOption> | undefined;
  title: string;
}

const LearningRequestFormEntry: FC<Props> = ({ options, title, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.title}>{t(`${title}`)}</div>
      <div className={styles.buttons}>
        {options?.map((option) => {
          const { label, value } = option;

          return (
            <button
              key={`form-entry-btn-${value}`}
              className={styles['form-entry-button']}
              onClick={() => onSubmit(value)}
            >
              <div className={styles['button-body']}>
                <div className={styles['image-container']}>
                  <Image
                    alt={label}
                    src={`/static/images/icons/${value}-icon.svg`}
                    width="48"
                    height="48"
                  />
                </div>
                <div className={styles['form-entry-button-text']}>{label}</div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LearningRequestFormEntry;
